require('./lbaNav.scss');

const $inject = [];
const lbaNav = function () {
  return {
    scope: {
      target: '<'
    },
    restrict: 'A',
    bindToController: true,
    controller: 'lbaNavCtrl',
    controllerAs: 'vm',
    template: require('./lbaNav.html')
  }
};

lbaNav.$inject = $inject;

export default lbaNav;



// WEBPACK FOOTER //
// ./src/components/lbaNav/lbaNavDir.js